/**
 * Образцы данных по контрактам — для заглушек (мок API клиента, заглушка сервера) и тестов.
 * Числа правдоподобные, но не баланс: настоящие данные — `packages/engine/data` (E2).
 */
import type { PlayerState } from "../api";
import type { RunState } from "../wave-log";
import { sampleLeagueFields } from "./league";
import { samplePaidFields } from "./payments";
import { sampleProgressFields } from "./progress";
import { sampleSeasonFields } from "./season";

/** Версия баланса заглушек. */
export const FIXTURE_BALANCE_VERSION = "2026-10-24.0";

/** Фиксированные UUID заглушек. */
export const FIXTURE_IDS = {
  player: "00000000-0000-4000-8000-000000000001",
  run: "00000000-0000-4000-8000-000000000002",
} as const;

/** Забежка заглушки: волна 1, один Gunner. */
export function sampleRunState(wave = 1): RunState {
  return {
    runId: FIXTURE_IDS.run,
    wave,
    heroes: [{ heroId: "gunner", slot: 0, level: 1, stars: 0 }],
    tech: {},
    boosts: [],
    hqHp: 1000,
    autoSkills: false,
  };
}

/** Состояние игрока заглушки на момент `now`. */
export function samplePlayerState(now: number, overrides: Partial<PlayerState> = {}): PlayerState {
  return {
    player: {
      id: FIXTURE_IDS.player,
      name: "Guest",
      telegramId: null,
      locale: "en",
      localeChosen: false,
      allowsWriteToPm: null,
      testAccount: false,
      adminTools: false,
      testResetAt: null,
      fieldScale: "a",
      createdAt: now - 86_400_000,
    },
    coins: 120,
    heroes: [
      { heroId: "gunner", unlocked: true, level: 1, stars: 0 },
      { heroId: "bomber", unlocked: false, level: 1, stars: 0 },
      { heroId: "sparky", unlocked: false, level: 1, stars: 0 },
      { heroId: "blaze", unlocked: false, level: 1, stars: 0 },
      { heroId: "frosty", unlocked: false, level: 1, stars: 0 },
    ],
    tech: {},
    run: sampleRunState(),
    next: { wave: 1, seed: 12345 },
    bestWave: 0,
    ...sampleProgressFields(now),
    ...sampleSeasonFields(),
    ...sampleLeagueFields(),
    offline: { coins: 0, seconds: 0, capSeconds: 8 * 3600 },
    ...samplePaidFields(),
    balanceVersion: FIXTURE_BALANCE_VERSION,
    serverTime: now,
    ...overrides,
  };
}
